import type { UseControllerProps } from 'react-hook-form';
import { useController, useFormContext } from 'react-hook-form';

import { RadioGroup } from 'components/UI/Tailwind/RadioGroup';

export type FormRadioGroup<
  TTag extends React.ElementType = 'div',
  TType = string,
> = Omit<React.ComponentProps<typeof RadioGroup<TTag, TType>>, 'name'> &
  Pick<UseControllerProps, 'name'>;

export function FormRadioGroup<
  TTag extends React.ElementType = 'div',
  TType = string,
>({ disabled, name, ...props }: FormRadioGroup<TTag, TType>) {
  const { control, formState } = useFormContext();

  const { field } = useController({
    control,
    name,
  });

  return (
    // @ts-expect-error
    <RadioGroup
      {...props}
      {...field}
      disabled={disabled || formState.isSubmitting}
      error={formState.errors[name]?.message}
      onChange={(...args) => {
        field.onChange(...args);
        props.onChange?.(...args);
      }}
    />
  );
}
